const Star = ({ filled }) => (
  <svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
      fill={filled ? '#F59E0B' : '#4B5563'}
      stroke={filled ? '#F59E0B' : '#4B5563'}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const QuizStars = ({ score, total }) => {
  return (
    <div className="flex items-center justify-center gap-4">
      {Array.from({ length: total }, (_, i) => (
        <Star key={i} filled={i < score} />
      ))}
    </div>
  );
};

export default QuizStars;
